import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Collapse,
  title: 'Collapse',
  category: ComponentCategory.Layout,
  droppable: false,
};
